export enum ClientTypeEnum {
    CLIENT = 'client',
    ADMIN = 'admin',
    ATTENDANT = 'attendant'
}

export function getTextClientTypeEnum(client_type_enum: ClientTypeEnum): string {
    switch (client_type_enum) {
        case ClientTypeEnum.CLIENT:
            return 'Cliente';
        case ClientTypeEnum.ADMIN:
            return 'Administrador';
        case ClientTypeEnum.ATTENDANT:
            return 'Atendente';
        default:
            return 'N/A';
    }
}